import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonPipesModule } from '../common/commonpipes.module';
import { NgxTranslateModule } from '../translate/translate.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { FaqModule } from '../faq/faq.module';
import { JournalModule } from '../journal/journal.module';



@NgModule({
    declarations: [
        HomeComponent
    ],
    imports: [
        NgbModule,
        CommonModule,
        FontAwesomeModule,
        NgxTranslateModule,
        RouterModule,
        HomeRoutingModule,
        CommonPipesModule,
        ReactiveFormsModule,
        JournalModule,
        FaqModule
  
    ],
    exports: [HomeComponent]
})
export class HomeModule { }


